module.exports = __webpack_public_path__ + "static/media/micro_classroom.1a4214f6.jpg";